export const countryCodesList = [
    { countryName: "Afghanistan", country: "AF", code: 93 },
    { countryName: "Albania", country: "AL", code: 355 },
    { countryName: "Algeria", country: "DZ", code: 213 },
    { countryName: "Andorra", country: "AD", code: 376 },
    { countryName: "Angola", country: "AO", code: 244 },
    { countryName: "Antigua and Barbuda", country: "AG", code: 1268 },
    { countryName: "Argentina", country: "AR", code: 54 },
    { countryName: "Armenia", country: "AM", code: 374 },
    { countryName: "Australia", country: "AU", code: 61 },
    { countryName: "Austria", country: "AT", code: 43 },
    { countryName: "Azerbaijan", country: "AZ", code: 994 },
    { countryName: "Bahamas", country: "BS", code: 1242 },
    { countryName: "Bahrain", country: "BH", code: 973 },
    { countryName: "Bangladesh", country: "BD", code: 880 },
    { countryName: "Barbados", country: "BB", code: 1246 },
    { countryName: "Belarus", country: "BY", code: 375 },
    { countryName: "Belgium", country: "BE", code: 32 },
    { countryName: "Belize", country: "BZ", code: 501 },
    { countryName: "Benin", country: "BJ", code: 229 },
    { countryName: "Bhutan", country: "BT", code: 975 },
    { countryName: "Bolivia", country: "BO", code: 591 },
    { countryName: "Bosnia and Herzegovina", country: "BA", code: 387 },
    { countryName: "Botswana", country: "BW", code: 267 },
    { countryName: "Brazil", country: "BR", code: 55 },
    { countryName: "Brunei", country: "BN", code: 673 },
    { countryName: "Bulgaria", country: "BG", code: 359 },
    { countryName: "Burkina Faso", country: "BF", code: 226 },
    { countryName: "Burundi", country: "BI", code: 257 },
    { countryName: "Cabo Verde", country: "CV", code: 238 },
    { countryName: "Cambodia", country: "KH", code: 855 },
    { countryName: "Cameroon", country: "CM", code: 237 },
    { countryName: "Canada", country: "CA", code: 1 },
    { countryName: "Central African Republic", country: "CF", code: 236 },
    { countryName: "Chad", country: "TD", code: 235 },
    { countryName: "Chile", country: "CL", code: 56 },
    { countryName: "China", country: "CN", code: 86 },
    { countryName: "Colombia", country: "CO", code: 57 },
    { countryName: "Comoros", country: "KM", code: 269 },
    { countryName: "Congo (Congo-Brazzaville)", country: "CG", code: 242 },
    { countryName: "Congo (Democratic Republic)", country: "CD", code: 243 },
    { countryName: "Costa Rica", country: "CR", code: 506 },
    { countryName: "Croatia", country: "HR", code: 385 },
    { countryName: "Cuba", country: "CU", code: 53 },
    { countryName: "Cyprus", country: "CY", code: 357 },
    { countryName: "Czech Republic", country: "CZ", code: 420 },
    { countryName: "Denmark", country: "DK", code: 45 },
    { countryName: "Djibouti", country: "DJ", code: 253 },
    { countryName: "Dominica", country: "DM", code: 1767 },
    { countryName: "Dominican Republic", country: "DO", code: 1 },
    { countryName: "Ecuador", country: "EC", code: 593 },
    { countryName: "Egypt", country: "EG", code: 20 },
    { countryName: "El Salvador", country: "SV", code: 503 },
    { countryName: "Equatorial Guinea", country: "GQ", code: 240 },
    { countryName: "Eritrea", country: "ER", code: 291 },
    { countryName: "Estonia", country: "EE", code: 372 },
    { countryName: "Eswatini", country: "SZ", code: 268 },
    { countryName: "Ethiopia", country: "ET", code: 251 },
    { countryName: "Fiji", country: "FJ", code: 679 },
    { countryName: "Finland", country: "FI", code: 358 },
    { countryName: "France", country: "FR", code: 33 },
    { countryName: "Gabon", country: "GA", code: 241 },
    { countryName: "Gambia", country: "GM", code: 220 },
    { countryName: "Georgia", country: "GE", code: 995 },
    { countryName: "Germany", country: "DE", code: 49 },
    { countryName: "Ghana", country: "GH", code: 233 },
    { countryName: "Greece", country: "GR", code: 30 },
    { countryName: "Grenada", country: "GD", code: 1473 },
    { countryName: "Guatemala", country: "GT", code: 502 },
    { countryName: "Guinea", country: "GN", code: 224 },
    { countryName: "Guinea-Bissau", country: "GW", code: 245 },
    { countryName: "Guyana", country: "GY", code: 592 },
    { countryName: "Haiti", country: "HT", code: 509 },
    { countryName: "Honduras", country: "HN", code: 504 },
    { countryName: "Hungary", country: "HU", code: 36 },
    { countryName: "Iceland", country: "IS", code: 354 },
    { countryName: "India", country: "IN", code: 91 },
    { countryName: "Indonesia", country: "ID", code: 62 },
    { countryName: "Iran", country: "IR", code: 98 },
    { countryName: "Iraq", country: "IQ", code: 964 },
    { countryName: "Ireland", country: "IE", code: 353 },
    { countryName: "Israel", country: "IL", code: 972 },
    { countryName: "Italy", country: "IT", code: 39 },
    { countryName: "Jamaica", country: "JM", code: 1 },
    { countryName: "Japan", country: "JP", code: 81 },
    { countryName: "Jordan", country: "JO", code: 962 },
    { countryName: "Kazakhstan", country: "KZ", code: 7 },
    { countryName: "Kenya", country: "KE", code: 254 },
    { countryName: "Kiribati", country: "KI", code: 686 },
    { countryName: "Korea (North)", country: "KP", code: 850 },
    { countryName: "Korea (South)", country: "KR", code: 82 },
    { countryName: "Kuwait", country: "KW", code: 965 },
    { countryName: "Kyrgyzstan", country: "KG", code: 996 },
    { countryName: "Laos", country: "LA", code: 856 },
    { countryName: "Latvia", country: "LV", code: 371 },
    { countryName: "Lebanon", country: "LB", code: 961 },
    { countryName: "Lesotho", country: "LS", code: 266 },
    { countryName: "Liberia", country: "LR", code: 231 },
    { countryName: "Libya", country: "LY", code: 218 },
    { countryName: "Liechtenstein", country: "LI", code: 423 },
    { countryName: "Lithuania", country: "LT", code: 370 },
    { countryName: "Luxembourg", country: "LU", code: 352 },
    { countryName: "Madagascar", country: "MG", code: 261 },
    { countryName: "Malawi", country: "MW", code: 265 },
    { countryName: "Malaysia", country: "MY", code: 60 },
    { countryName: "Maldives", country: "MV", code: 960 },
    { countryName: "Mali", country: "ML", code: 223 },
    { countryName: "Malta", country: "MT", code: 356 },
    { countryName: "Marshall Islands", country: "MH", code: 692 },
    { countryName: "Mauritania", country: "MR", code: 222 },
    { countryName: "Mauritius", country: "MU", code: 230 },
    { countryName: "Mexico", country: "MX", code: 52 },
    { countryName: "Micronesia", country: "FM", code: 691 },
    { countryName: "Moldova", country: "MD", code: 373 },
    { countryName: "Monaco", country: "MC", code: 377 },
    { countryName: "Mongolia", country: "MN", code: 976 },
    { countryName: "Montenegro", country: "ME", code: 382 },
    { countryName: "Morocco", country: "MA", code: 212 },
    { countryName: "Mozambique", country: "MZ", code: 258 },
    { countryName: "Myanmar", country: "MM", code: 95 },
    { countryName: "Namibia", country: "NA", code: 264 },
    { countryName: "Nauru", country: "NR", code: 674 },
    { countryName: "Nepal", country: "NP", code: 977 },
    { countryName: "Netherlands", country: "NL", code: 31 },
    { countryName: "New Zealand", country: "NZ", code: 64 },
    { countryName: "Nicaragua", country: "NI", code: 505 },
    { countryName: "Niger", country: "NE", code: 227 },
    { countryName: "Nigeria", country: "NG", code: 234 },
    { countryName: "North Macedonia", country: "MK", code: 389 },
    { countryName: "Norway", country: "NO", code: 47 },
    { countryName: "Oman", country: "OM", code: 968 },
    { countryName: "Pakistan", country: "PK", code: 92 },
    { countryName: "Palau", country: "PW", code: 680 },
    { countryName: "Panama", country: "PA", code: 507 },
    { countryName: "Papua New Guinea", country: "PG", code: 675 },
    { countryName: "Paraguay", country: "PY", code: 595 },
    { countryName: "Peru", country: "PE", code: 51 },
    { countryName: "Philippines", country: "PH", code: 63 },
    { countryName: "Poland", country: "PL", code: 48 },
    { countryName: "Portugal", country: "PT", code: 351 },
    { countryName: "Qatar", country: "QA", code: 974 },
    { countryName: "Romania", country: "RO", code: 40 },
    { countryName: "Russia", country: "RU", code: 7 },
    { countryName: "Rwanda", country: "RW", code: 250 },
    { countryName: "Saint Kitts and Nevis", country: "KN", code: 1869 },
    { countryName: "Saint Lucia", country: "LC", code: 1758 },
    { countryName: "Saint Vincent and the Grenadines", country: "VC", code: 1784 },
    { countryName: "Samoa", country: "WS", code: 685 },
    { countryName: "San Marino", country: "SM", code: 378 },
    { countryName: "Sao Tome and Principe", country: "ST", code: 239 },
    { countryName: "Saudi Arabia", country: "SA", code: 966 },
    { countryName: "Senegal", country: "SN", code: 221 },
    { countryName: "Serbia", country: "RS", code: 381 },
    { countryName: "Seychelles", country: "SC", code: 248 },
    { countryName: "Sierra Leone", country: "SL", code: 232 },
    { countryName: "Singapore", country: "SG", code: 65 },
    { countryName: "Slovakia", country: "SK", code: 421 },
    { countryName: "Slovenia", country: "SI", code: 386 },
    { countryName: "Solomon Islands", country: "SB", code: 677 },
    { countryName: "Somalia", country: "SO", code: 252 },
    { countryName: "South Africa", country: "ZA", code: 27 },
    { countryName: "South Sudan", country: "SS", code: 211 },
    { countryName: "Spain", country: "ES", code: 34 },
    { countryName: "Sri Lanka", country: "LK", code: 94 },
    { countryName: "Sudan", country: "SD", code: 249 },
    { countryName: "Suriname", country: "SR", code: 597 },
    { countryName: "Sweden", country: "SE", code: 46 },
    { countryName: "Switzerland", country: "CH", code: 41 },
    { countryName: "Syria", country: "SY", code: 963 },
    { countryName: "Taiwan", country: "TW", code: 886 },
    { countryName: "Tajikistan", country: "TJ", code: 992 },
    { countryName: "Tanzania", country: "TZ", code: 255 },
    { countryName: "Thailand", country: "TH", code: 66 },
    { countryName: "Timor-Leste", country: "TL", code: 670 },
    { countryName: "Togo", country: "TG", code: 228 },
    { countryName: "Tonga", country: "TO", code: 676 },
    { countryName: "Trinidad and Tobago", country: "TT", code: 1868 },
    { countryName: "Tunisia", country: "TN", code: 216 },
    { countryName: "Turkey", country: "TR", code: 90 },
    { countryName: "Turkmenistan", country: "TM", code: 993 },
    { countryName: "Tuvalu", country: "TV", code: 688 },
    { countryName: "Uganda", country: "UG", code: 256 },
    { countryName: "Ukraine", country: "UA", code: 380 },
    { countryName: "United Arab Emirates", country: "AE", code: 971 },
    { countryName: "United Kingdom", country: "GB", code: 44 },
    { countryName: "United States", country: "US", code: 1 },
    { countryName: "Uruguay", country: "UY", code: 598 },
    { countryName: "Uzbekistan", country: "UZ", code: 998 },
    { countryName: "Vanuatu", country: "VU", code: 678 },
    { countryName: "Vatican City", country: "VA", code: 379 },
    { countryName: "Venezuela", country: "VE", code: 58 },
    { countryName: "Vietnam", country: "VN", code: 84 },
    { countryName: "Yemen", country: "YE", code: 967 },
    { countryName: "Zambia", country: "ZM", code: 260 },
    { countryName: "Zimbabwe", country: "ZW", code: 263 }
];